// removed by extract-text-webpack-plugin
module.exports = {"Interior360Item":"Interior360Item","Interior360Item__link":"Interior360Item__link","Interior360Item__border":"Interior360Item__border","current":"current","Interior360Item__box":"Interior360Item__box"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/interior360-item/styles.css
// module id = 907
// module chunks = 0 1